export const DEFAULT_MESSAGE_SOUND_KEY = 'classic';
export const MESSAGE_SOUND_STORAGE_KEY = 'messageSoundKey';

export const MESSAGE_SOUND_OPTIONS = [
	{
		key: 'classic',
		name: '经典提示音',
		src: require('@/assets/audio/tip.wav')
	},
	{
		key: 'chime',
		name: '清脆铃声',
		src: require('@/assets/audio/notify-chime.wav')
	},
	{
		key: 'pop',
		name: '轻快气泡',
		src: require('@/assets/audio/notify-pop.wav')
	},
	{
		key: 'alert',
		name: '明亮提醒',
		src: require('@/assets/audio/notify-alert.wav')
	},
	{
		key: 'soft',
		name: '柔和提示',
		src: require('@/assets/audio/notify-soft.wav')
	}
];

export function getMessageSoundOption(key) {
	return MESSAGE_SOUND_OPTIONS.find(item => item.key === key) || MESSAGE_SOUND_OPTIONS[0];
}
